import { render, staticRenderFns } from "./JinNangRepoTable.vue?vue&type=template&id=38d12236&"
import script from "./JinNangRepoTable.vue?vue&type=script&lang=js&"
export * from "./JinNangRepoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports